let secondCross = ''; // 本地调试如有跨域问题则赋值，若上线则把cross置空，并改http.js里的域名 /secondApi
const fuelAndFeeAPI = {
  // 新增地址
  addAddress: {
    method: 'post',
    url: '/logistics/fuelTollAddress/add',
    mask: false // 判断是否需要加载loading框
  },
  // 修改地址
  editAddress: {
    method: 'post',
    url: '/logistics/fuelTollAddress/edit',
    mask: false // 判断是否需要加载loading框
  },
  // 删除地址
  delAddress: {
    method: 'post',
    url: '/logistics/fuelTollAddress/removeIds',
    mask: true // 判断是否需要加载loading框
  },
  // 查询地址
  getAddressList: {
    method: 'get',
    url: '/logistics/fuelTollAddress/list',
    mask: false // 判断是否需要加载loading框
  },
  // 获取加油-过路费地址详细信息
  getAddressDetail: {
    method: 'get',
    url: '/logistics/fuelTollAddress/getInfo',
    mask: true // 判断是否需要加载loading框
  },
  // 查询加油记录明细列表
  getFuelRecordList: {
    method: 'get',
    url: '/logistics/fuelRecord/list',
    mask: true // 判断是否需要加载loading框
  },
  // 删除加油记录明细列表
  deleteFuelRecord: {
    method: 'post',
    url: '/logistics/fuelRecord/removeIds',
    mask: true // 判断是否需要加载loading框
  },
  // 获取加油记录明细详细信息
  getFuelRecordInfo: {
    method: 'get',
    url: '/logistics/fuelRecord/getInfo',
    mask: true // 判断是否需要加载loading框
  },
  // 查询etc过路费和油费记录明细合并列表
  getAllRecordList: {
    method: 'get',
    url: '/logistics/etcTollRecord/merSumlist',
    mask: true // 判断是否需要加载loading框
  },
  // 查看etc过路费记录明细列表
  getEtcTollRecordList: {
    method: 'get',
    url: '/logistics/etcTollRecord/list',
    mask: true // 判断是否需要加载loading框
  },
  // 删除etc过路费记录
  deleteEtcTollRecord: {
    method: 'post',
    url: '/logistics/etcTollRecord/remove',
    mask: true // 判断是否需要加载loading框
  },
  // 查看etc过路费记录明细详情
  getEtcTollRecordInfo: {
    method: 'get',
    url: '/logistics/etcTollRecord/getInfo',
    mask: true // 判断是否需要加载loading框
  },
  // 查询司机油卡/ETC卡
  queryFuelAndEtc: {
    method: 'get',
    url: '/logistics/fuelCard/queryFuelAndEtc',
    mask: true // 判断是否需要加载loading框
  },
  // 查询司机油卡/ETC卡
  getMerTotal: {
    method: 'get',
    url: '/logistics/etcTollRecord/merTotal',
    mask: true // 判断是否需要加载loading框
  },
  // 加油图片识别
  ocrAnalysis: {
    method: 'post',
    url: '/logistics/fuelRecord/ocrAnalysis',
    mask: true // 判断是否需要加载loading框
  },
  // 油卡查询
  queryFuelCardByPaymentMethod: {
    method: 'get',
    url: '/logistics/fuelCard/queryFuelCardByPaymentMethod',
    mask: false // 判断是否需要加载loading框
  },
  // 上传加油记录
  addFuelRecord: {
    method: 'post',
    url: '/logistics/fuelRecord/add',
    mask: true // 判断是否需要加载loading框
  },
  // 编辑保存加油记录
  editFuelRecord: {
    method: 'post',
    url: '/logistics/fuelRecord/edit',
    mask: true // 判断是否需要加载loading框
  },
  // 加油记录处理申请
  applayFuelRecord: {
    method: 'post',
    url: '/logistics/fuelRecord/applay',
    mask: true // 判断是否需要加载loading框
  },
  // 上传过路费记录
  uploadTollRecords: {
    method: 'post',
    url: '/logistics/etcTollRecord/add',
    mask: true // 判断是否需要加载loading框
  },
  // 修改过路费记录
  editTollRecords: {
    method: 'post',
    url: '/logistics/etcTollRecord/edit',
    mask: true // 判断是否需要加载loading框
  },
  // 申请处理过路费记录
  applyTollRecords: {
    method: 'post',
    url: '/logistics/etcTollRecord/applay',
    mask: true // 判断是否需要加载loading框
  },
  // 设为默认地址
  editDefaultFlag: {
    method: 'get',
    url: '/logistics/fuelTollAddress/editDefaultFlag',
    mask: false // 判断是否需要加载loading框
  },

};

export default fuelAndFeeAPI;



// WEBPACK FOOTER //
// ./src/api/fuelAndFee.js